// Site/AddSites.jsx
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import siteService from "../../services/siteService";
import SiteForm from "./SiteForm/SiteForm";


const AddSites = () => {
  const { studyID } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleAdd = async (formData) => {
    const payload = {
      site_code: formData.site_code,
      site_name: `Site ${String(formData.site_code).padStart(4, "0")} - ${formData.institution}`,
      institution: formData.institution,
      country: formData.country,
      contact: formData.contact_person,
      contact_email: formData.email,
      timezone: formData.timezone,
    };

    console.log("📦 Final payload being sent to backend:", payload);

    try {
      setLoading(true);
      await siteService.addSite(studyID, payload);
      toast.success("Site created successfully");
      navigate(-1);
    } catch (error) {
      console.error("❌ API error details:", error.response?.data || error.message);
      
      // Get the error message in a user-friendly format
      let errorMessage = "Failed to create site.";
      
      if (error.response?.data?.error) {
        // Handle standard API error format
        errorMessage = error.response.data.error;
        
        // Check if it's a stringified object (legacy format)
        if (typeof errorMessage === 'string' && errorMessage.startsWith('{') && errorMessage.includes('__all__')) {
          try {
            const parsedError = JSON.parse(errorMessage.replace(/'/g, '"'));
            if (parsedError.__all__ && parsedError.__all__[0]) {
              errorMessage = parsedError.__all__[0];
            }
          } catch (e) {
            // If parsing fails, use the original error message
            console.warn("Error parsing error message:", e);
          }
        }
      }
      
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return <SiteForm onSubmit={handleAdd} isLoading={loading} />;
};

export default AddSites;
